export const processImageForDisplay = (image: string): string => {
  if (!image) return "";
  return image.includes(":") ? image.split(":")[1] : image;
};
